import React, { ChangeEvent, useState } from "react"
import { Radio } from "@mui/material"
import { Cancel, CheckCircle, TripOrigin } from "@mui/icons-material"
import { useAuth } from "../../../contexts/AuthContext"

const QuestionView = (props: any) => {
  const { noOfItems, sn, isLast, question, moveToNext, endQuiz } = props
  const { getUserJWT, setIsLoadingOverlayDisplay } = useAuth()

  const [checkedAnswer, setCheckedAnswer] = useState<string | null>(null)
  const [checkIsCorrect, setCheckIsCorrect] = useState<boolean | null>(null)
  const [loading, setLoading] = useState(false)
  //   function
  const handleAnswerCheck = (e: ChangeEvent<HTMLInputElement>) => {
    const answer = e.target.value
    setCheckedAnswer(answer)
    checkAnswer(answer)
  }
  const checkAnswer = async (id: string) => {

  }
  const goToNext = () => {
    setCheckedAnswer(null)
    setCheckIsCorrect(null)
    moveToNext()
  }
  const handleSubmit = () => {
    endQuiz()
  }
  return (
    <div style={{minWidth:"400px"}}>
      <header className=" w-full p-5 bg-kyzzen-secondary rounded-x10 text-xl font-medium flex flex-col gap-5">
        <span className="text-accent-main">
          Question {sn}/{noOfItems}
        </span>
        <span className="text-base font-normal">{question?.text}</span>
      </header>
      <div className="w-full p-5 grid gap-5">
        {question?.answers?.map((answer:any) => {
          const isChecked = checkedAnswer === answer?.id
          return (
            <label
              className="radio-group flex gap-5 items-center"
              key={answer?.id}
            >
              <Radio
                name="answer"
                id={answer?.id}
                value={answer?.id}
                checked={isChecked}
                onChange={handleAnswerCheck}
                checkedIcon={<TripOrigin className="text-accent-main" />}
              />
              <span className="flex-1 max-w-xs">{answer?.text}</span>
              {!loading && isChecked && (
                <span
                  className={`flex items-center gap-3 ${
                    checkIsCorrect === false
                      ? "text-error-50"
                      : checkIsCorrect === true
                      ? "text-success-50"
                      : ""
                  }`}
                >
                  {checkIsCorrect === false && (
                    <>
                      <Cancel />
                      <span>Wrong</span>
                    </>
                  )}
                  {checkIsCorrect === true && (
                    <>
                      <CheckCircle />
                      <span>Correct</span>
                    </>
                  )}
                </span>
              )}
            </label>
          )
        })}
        {/* {checkIsCorrect && ( */}
          <button
            className="gradient-outline-btn hover-gradient-text justify-self-end px-10 py-2 text-sm"
            onClick={isLast ? handleSubmit : goToNext}
          >
            {isLast ? "Submit" : "Next"}
          </button>
        {/* )} */}
      </div>
    </div>
  )
}

export default QuestionView
